/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technologies_Unresolved_UnknownInputs */

const en_us2_technologies_unresolved_unknown = /** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not identify this technology from reliable public sources.`)
};

const es_es2_technologies_unresolved_unknown = /** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hemos podido identificar esta tecnología mediante fuentes públicas fiables.`)
};

const ru_technologies_unresolved_unknown = /** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нам не удалось найти информацию об этой технологии в надёжных открытых источниках.`)
};

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const id_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const ms_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const da_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const de_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const es_mx2_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const fil_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const fr_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const it_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const hu_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const nl_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const no_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const pl_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const pt_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const pt_br2_technologies_unresolved_unknown = pt_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const ro_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const fi_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const sv_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const vi_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const tr_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const cs_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const bg_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const uk_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const ar_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const hi_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const th_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const ja_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const zh_cn2_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const zh_hant1_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/** @type {(inputs: Technologies_Unresolved_UnknownInputs) => LocalizedString} */
const ko_technologies_unresolved_unknown = en_us2_technologies_unresolved_unknown;

/**
* | output |
* | --- |
* | "We could not identify this technology from reliable public sources." |
*
* @param {Technologies_Unresolved_UnknownInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const technologies_unresolved_unknown = /** @type {((inputs?: Technologies_Unresolved_UnknownInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technologies_Unresolved_UnknownInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_technologies_unresolved_unknown(inputs)
	if (locale === "ms") return ms_technologies_unresolved_unknown(inputs)
	if (locale === "da") return da_technologies_unresolved_unknown(inputs)
	if (locale === "de") return de_technologies_unresolved_unknown(inputs)
	if (locale === "en-US") return en_us2_technologies_unresolved_unknown(inputs)
	if (locale === "es-ES") return es_es2_technologies_unresolved_unknown(inputs)
	if (locale === "es-MX") return es_mx2_technologies_unresolved_unknown(inputs)
	if (locale === "fil") return fil_technologies_unresolved_unknown(inputs)
	if (locale === "fr") return fr_technologies_unresolved_unknown(inputs)
	if (locale === "it") return it_technologies_unresolved_unknown(inputs)
	if (locale === "hu") return hu_technologies_unresolved_unknown(inputs)
	if (locale === "nl") return nl_technologies_unresolved_unknown(inputs)
	if (locale === "no") return no_technologies_unresolved_unknown(inputs)
	if (locale === "pl") return pl_technologies_unresolved_unknown(inputs)
	if (locale === "pt-BR") return pt_br2_technologies_unresolved_unknown(inputs)
	if (locale === "pt") return pt_technologies_unresolved_unknown(inputs)
	if (locale === "ro") return ro_technologies_unresolved_unknown(inputs)
	if (locale === "fi") return fi_technologies_unresolved_unknown(inputs)
	if (locale === "sv") return sv_technologies_unresolved_unknown(inputs)
	if (locale === "vi") return vi_technologies_unresolved_unknown(inputs)
	if (locale === "tr") return tr_technologies_unresolved_unknown(inputs)
	if (locale === "cs") return cs_technologies_unresolved_unknown(inputs)
	if (locale === "bg") return bg_technologies_unresolved_unknown(inputs)
	if (locale === "ru") return ru_technologies_unresolved_unknown(inputs)
	if (locale === "uk") return uk_technologies_unresolved_unknown(inputs)
	if (locale === "ar") return ar_technologies_unresolved_unknown(inputs)
	if (locale === "hi") return hi_technologies_unresolved_unknown(inputs)
	if (locale === "th") return th_technologies_unresolved_unknown(inputs)
	if (locale === "ja") return ja_technologies_unresolved_unknown(inputs)
	if (locale === "zh-CN") return zh_cn2_technologies_unresolved_unknown(inputs)
	if (locale === "zh-Hant") return zh_hant1_technologies_unresolved_unknown(inputs)
	return ko_technologies_unresolved_unknown(inputs)
});
export { technologies_unresolved_unknown as "technologies.unresolved.unknown" }